<template>
  <div class="product__item">

    <router-link :to="{name:'ProductDetail', params:{id:productObject.id,type:productObject.type?productObject.type:type}}">

        <img :src="getImage(productObject)" :class="{'noImage':!hasImage(productObject)}" alt="">
        <div class="product__item__body">
        <h2 class="product__item__title" v-if="productObject.title">{{ productObject.title }}</h2>
        <h2 class="product__item__title" v-if="productObject.name">{{ productObject.name }}</h2>
        </div>
    </router-link>

      <button  v-if="addvisible  && !isFavorite(productObject)"  class="btn__favorite" @click="()=>addToCart(productObject,type)"> Ajouter au Favoris </button>
      <button  v-if="addvisible  && isFavorite(productObject)"  class="btn__favorite isFavorite"> Favoris </button>
      <router-link v-if="addvisible  && isFavorite(productObject)" to="/cart">
          <button class="btn__favorite isFavorite goFavorite">  Voir Favoris </button>
      </router-link>
      <button  v-if="removeIsVisible"  class="btn__favorite btn__delete" @click="()=>deleteMovie(productObject)"> Delete </button>
  </div>
</template>

<script>

    import { Carousel3d, Slide } from 'vue-carousel-3d';
export default {
  name: 'ProductCard',
    components: {
        Slide,
    },
  props: {
    productObject: Object,
      type:String,
      addvisible:Boolean,
      removeIsVisible:Boolean
  },
    methods: {
        addToCart: function (data,type) {
            this.$store.commit('addToCart', {data,type} )
        },
        getImage(data) {
            let url = 'img/logo_giant.png';
            if (data.poster_path) {
                url = 'https://image.tmdb.org/t/p/w500' + data.poster_path + '?api_key=07b774c956a772a71371e0875cfec69e';
            }
            return url
        },
        deleteMovie (data) {
            this.$store.commit('DELETE_MOVIE', data.id)
        },
        isFavorite(data){
            if(this.$store.state.cart.length > 0){
                let name = data.title ? data.title : data.name;
                return this.$store.state.cart.some(el=>el.title === name)
            }
        },
        hasImage(data){
            return (data.poster_path || data.profile_path)
        }
    },

};
</script>

<style lang="scss" scoped>
    .product__item{
        padding: 0 !important;
        width: 300px;
        margin:14px;
        border-radius: 10px;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 15px 0 rgba(0, 0, 0, 0.19);
        float: left;
        overflow: hidden;
        img{

            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            width: 100%;
            height: auto;
            min-height: 450px;

        }
        .product__item__body{
            h2{
                color: #fff;
                width: 80%;
                height: 4rem;
                margin-left: 15px;
                font-size: 1.2em;
            }
        }
        a{
            text-decoration: none;
        }
        .btn__favorite{
            display:block;
            border:1px solid #fff;
            border-radius:5px;
            padding:4px;
            width:140px;
            background-color: #232323;
            color: #fff;
            position: relative;
            bottom: 10px;
            margin: 0 auto;
            transition: 0.3s
        }
        .btn__favorite:hover{
            cursor: pointer;
            background-color: #fff ;
            color: #9c0204;
        }
        .isFavorite{
            border:1px solid green;
            background-color: green ;
            color: #fff;
            display: inline-block;
            width: 80px;
            margin-right: 20px;
            margin-left: 20px;
        }
        .isFavorite:hover{
            border:1px solid green;
            background-color: green ;
            color: #fff;
            font-size: 13px;
        }
        .goFavorite{
            border:1px solid #fff;
            background-color: #232323;
            color: #fff;
            width: 140px;
        }
        .btn__delete{

            border:1px solid #fff;
            color: #fff;
            transition: 0.3s
        }
        .btn__delete:hover{

            background-color: #fff;
            color: #9c0204;
        }
        a{
            text-decoration: none;
        }
        .noImage{
            padding:175px 0;
            min-height: 0;
        }
    }

</style>
